var _defs, _circle, _circle2, _circle3, _path, _circle4, _circle5, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOruclickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c-logo-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#34D399"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 84,
    fill: "#0B1220"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78,
    fill: "url(#c-logo-gradient)",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 66,
    fill: "#0B1220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 138 64 A 52 52 0 1 0 138 136",
    stroke: "#FFFFFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 100,
    r: 6,
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 100,
    r: 12,
    stroke: "#FFFFFF",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 82 126 V 104",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 126 V 94",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 126 V 80",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 68 L 110 78 L 126 78 Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOruclickIcon);
export default __webpack_public_path__ + "static/media/oruclick-icon.dbb4afff9cd6e5a2a6b7d1ae04cd0a13.svg";
export { ForwardRef as ReactComponent };